import { Howl } from "howler";
import { Button } from "./buttonsLibrary";
import DeviceChecker from "../functions/helper.ts/DeviceChecker";

export class firstTouchAudio {
  private audioFirstTouch: boolean;
  private fakeBtn: Button;
  private firstAudio: Howl;
  constructor() {
    this.audioFirstTouch = false;
    let graph = new PIXI.Graphics();
    graph.beginFill(0xffffff);
    graph.lineStyle(0);
    graph.drawCircle(30, 30, 30);
    graph.endFill();
    let renderer = PIXI.autoDetectRenderer();
    var ra = renderer.generateTexture(graph);

    this.fakeBtn = new Button(
      new PIXI.Sprite(ra),
      new PIXI.Rectangle(-175, -50, 350, 100)
    ); // fix hitbox
    this.firstAudio = new Howl({
      html5: DeviceChecker.getInstance().checkIsAppleDevice(),
      src: ["sounds/tictoc.m4a?" + "version=" + Date.now()],
      volume: 0.0,
      sprite: {
        toc: [0, 0, false],
      },
    });
  }
  playAudio() {
    if (this.audioFirstTouch == false) {
      this.fakeBtn.setInteractive(true);
      this.firstAudio.play("toc");
      this.audioFirstTouch = true;
    }
  }
}
